<template>
  <div class="eaAreaMge">
    <!-- 物业区域 项目名称组件 -->
    <house-manage
      v-if="this.$store.state.areasTip"
      :selectedArr="selectArr2"
      :isMessage3="isMessage2"
      :hadSelectArr="hadSelectArr"
      :title="titleObj"
      :dataList="areasTipList"
      :page="page"
      :query1="queryparam1"
      @propertyVal="property"
      @propertyValArr="propertyValArr"
      @query="query"
    >

      <el-table-column v-if="checkbox" type="selection" width="55"></el-table-column>
      <el-table-column type="index" label="序号" width="60" v-bind:index="indexMethod" align="center"></el-table-column>
      <el-table-column
        prop="EaArea.CantonCode"
        label="行政区域"
        width="150"
        align="center"
        show-overflow-tooltip
      >
        <template slot-scope="scope">{{nationalRegion[scope.row.EaArea.CantonCode]}}</template>
      </el-table-column>
      <el-table-column
        prop="EaArea.EaAreaExternalCode"
        label="物业编号"
        width="200"
        align="center"
        show-overflow-tooltip
        v-if="titleObj.indefind!=='小区名称'"
      ></el-table-column>
      <el-table-column
        prop="BuildUnitOrgName"
        label="招标企业"
        width="200"
        align="center"
        show-overflow-tooltip
        v-if="titleObj.indefind==='小区名称'"
      ></el-table-column>
      <el-table-column
        prop="EaArea.EaAreaName"
        label="小区名称"
        width="200"
        align="center"
        show-overflow-tooltip
        v-if="titleObj.indefind==='小区名称'"
      ></el-table-column>
      <el-table-column
        prop="EaArea.EaAreaName"
        label="物业区域名称"
        width="200"
        align="center"
        show-overflow-tooltip
        v-if="titleObj.indefind!=='小区名称'"
      ></el-table-column>
      <el-table-column
        prop="EaArea.Address"
        label="详细地址"
        min-width="200"
        align="center"
        show-overflow-tooltip
      ></el-table-column>
      <template slot="pagination">
        <el-pagination
          @size-change="handleSizeChange"
          @current-change="pageChange"
          :current-page="page.currentPage"
          :page-sizes="[10, 20, 50, 100]"
          :page-size="page.currtNum"
          layout="total, sizes, prev, pager, next, jumper"
          :total="page.getCurrtNum"
        ></el-pagination>
      </template>
    </house-manage>
  </div>
</template>

<script>
import commonTitle from '@/assets/js/commonTitle.js';
import houseManage from './housManage';
import { EaAreaControllerSvr } from '@/service/EaAreaControllerSvr';
import { EaAreaQueryParaEx } from '@/models/queryparams/EaAreaQueryParaEx';
import { mapState } from 'vuex';
import { Page } from '@/models/page';
import nationalRegion from '@/utils/nationalRegion';
export default {
  components: { houseManage },
  props: {
    cantonCode: String,
    streetOfficeOrgCode: String,
    residentsCommitteeOrgCode: String,
    subdistrictOfficeCode: String,
    neighborhoodCommitteeCode: String,
    orgCode: String,
    showAll: Boolean,
    BuildUnitOrgName: Boolean,
    title: Object,
    eaAreaCodes: [Array, String],
    ownerTeamOrgCode: String,
    checkbox: String,
    isMessage: String,
    selectArr: Array,
    hadSelectArr: Array,
    // 加载此参数对应的子公司物业区域
    relationsForOrg: String,
  },
  data() {
    return {
      queryparam1: {},
      titleObj: {
        title: '选择物业区域',
        label1: '物业区域编号',
        label2: '物业区域名称',
        indefind: '标识作用'
      },
      selectArr2: [],
      isMessage2: 'true',
      areasTipList: [],
      eaAreaQueryParaEx: new EaAreaQueryParaEx(),
      page: new Page(),
      nationalRegion: nationalRegion
    };
  },
  watch: {
    hadSelectArr: {
      handler() {}
    },
    selectArr: {
      handler() {
        this.selectArr2 = this.selectArr;
      }
    },
    checkbox: {
      handler() {}
    },
    cantonCode: {
      handler() {
        this.eaAreaQueryParaEx.setParamByCantonCode(this.cantonCode);
        this.eaAreaQueryParaEx.setParamByStreetOfficeOrgCode(
          this.streetOfficeOrgCode
        );
        this.eaAreaQueryParaEx.setParamByResidentsCommitteeOrgCode(
          this.residentsCommitteeOrgCode
        );
        this.getData();
      }
    },
    streetOfficeOrgCode: {
      handler() {
        /* if (!this.residentsCommitteeOrgCode) { */
        this.eaAreaQueryParaEx.setParamByCantonCode(this.cantonCode);
        this.eaAreaQueryParaEx.setParamByStreetOfficeOrgCode(
          this.streetOfficeOrgCode
        );
        this.eaAreaQueryParaEx.setParamByResidentsCommitteeOrgCode(
          this.residentsCommitteeOrgCode
        );
        this.getData();
        /* } */
      }
    },
    residentsCommitteeOrgCode: {
      handler() {
        /* if (this.residentsCommitteeOrgCode) { */
        this.eaAreaQueryParaEx.setParamByCantonCode(this.cantonCode);
        this.eaAreaQueryParaEx.setParamByStreetOfficeOrgCode(
          this.streetOfficeOrgCode
        );
        this.eaAreaQueryParaEx.setParamByResidentsCommitteeOrgCode(
          this.residentsCommitteeOrgCode
        );
        this.getData();
        /* } */
      }
    },
    subdistrictOfficeCode: {
      handler() {
        this.eaAreaQueryParaEx.setParamByStreetOfficeOrgCode(
          this.subdistrictOfficeCode
        );
        this.getData();
      }
    },
    neighborhoodCommitteeCode: {
      handler() {
        this.eaAreaQueryParaEx.setParamByResidentsCommitteeOrgCode(
          this.neighborhoodCommitteeCode
        );
        this.getData();
      }
    },
    isMessage: {
      handler() {}
    }
  },
  computed: {
    ...mapState(['token']),
    mainTitle: () => {
      return commonTitle;
    }
  },
  created() {
    this.isMessage2 = this.isMessage;
    this.eaAreaConSvr = new EaAreaControllerSvr();
  },
  mounted() {
    if (this.title) {
      this.titleObj = this.title;
    }
    if (this.orgCode) {
      this.eaAreaQueryParaEx.setParamByRealtyMngOrgCode(this.orgCode);
    }
    if (this.eaAreaCodes) {
      this.eaAreaQueryParaEx.setParamByEaAreaCode_Enum(this.eaAreaCodes);
    }
    if (this.ownerTeamOrgCode) {
      this.eaAreaQueryParaEx.setParamByOwnerTeamOrgCode(this.ownerTeamOrgCode);
    }
    if (this.relationsForOrg) {
      this.eaAreaQueryParaEx.relationsForOrg=this.relationsForOrg
    }
    this.getData();
  },
  methods: {
    getData() {
      this.eaAreaConSvr
        .GetEaAreaList(
          this.token,
          this.eaAreaQueryParaEx,
          false,
          (this.page.currentPage - 1) * this.page.currtNum,
          this.page.currtNum,
          true,
          this.showAll
        )
        .then(res => {
          if(res._Items.length!=0){
            this.areasTipList = res._Items;
          }else{
            this.areasTipList =[];
          }
          this.page.getCurrtNum = res.TotalCount;
        })
        .catch(err => {
          this.$message({
            type: 'error' ,
            message: err.Msg
            });
        });
      /* this.eaAreaQueryParaEx.setParamByEaAreaCode("");
      this.eaAreaQueryParaEx.setParamByEaAreaName(""); */
    },
    query(queryparam) {
      this.queryparam1 = queryparam;
      if (queryparam.Identif === '小区名称') {
        if (queryparam.numInp !== '') {
          this.eaAreaQueryParaEx.setParamByEaAreaCode(queryparam.numInp);
        } else {
          this.eaAreaQueryParaEx.setParamByEaAreaCode('');
        }
        if (queryparam.nameInp !== '') {
          this.eaAreaQueryParaEx.setParamByEaAreaName(
            '%' + queryparam.nameInp + '%'
          );
        } else {
          this.eaAreaQueryParaEx.setParamByEaAreaName('');
        }
      } else {
        this.eaAreaQueryParaEx.setParamByEaAreaCode(queryparam.numInp);
        this.eaAreaQueryParaEx.setParamByEaAreaName(
          '%' + queryparam.nameInp + '%'
        );
      }

      this.getData();
    },
    property(propertyVal) {
      this.getData();
      if (this.checkbox) {
        this.$message({
          type: 'warning',
          message: '请勾选物业区域'
        });
        return;
      }
      this.$emit('propertyVal', propertyVal);
    },
    propertyValArr(propertyValArr) {
      this.$emit('propertyValArr', propertyValArr);
    },
    indexMethod(index) {
      return index + 1 + (this.page.currentPage - 1) * this.page.currtNum;
    },
    // page相关
    handleSizeChange(val) {
      this.page.currtNum = val;
      this.getData();
    },
    // page相关
    pageChange(val) {
      this.page.currentPage = val;
      this.getData();
    }
  }
};
</script>
<style lang="scss">
.eaAreaMge {
  .el-input__inner {
    border: 1px solid #dcdfe6 !important;
  }
  .el-icon-circle-check {
    display: none !important;
  }
  .el-input__validateIcon {
    display: none !important;
  }
}
</style>

<style lang="scss" scoped>
</style>
